// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import jQuery from 'jquery'
import Lodash from 'lodash'

// import "jquery"


global.jQuery = jQuery
global.$ = jQuery
global._ = Lodash
global.jQuery = require("jquery");
require("bootstrap");

// require('./../static/js/menu-2/modernizr.custom
// require("modernizr")
// require("path/to/script.exec.js");
require("./../static/js/menu-2/modernizr.custom.exec.js");
require('./../static/js/menu-2/jquery.dlmenu')
require('./../static/js/scripts')

require("es6-promise").polyfill();

let bus = new Vue()
global.bus = bus
Vue.config.productionTip = false

// var $ = (window.jQuery = require("jquery")); 
// import _ from 'lodash';
// import $ from "jquery";

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js